import { pageInfoTypes } from '../constants';

const defaultPageInfo = {
  layoutOptions: {
    isCheckoutUrl: false,

    hideHeader: false,
    hideSearch: false,
    hideGoalSelector: false,
    hideFooter: false,
    hideLearnerMinutes: false,
    hideNudges: false,

    disableDarkMode: false,

    useFreeLayout: false,

    // navbars
    showPlusNav: false,
    showEducatorNav: false,

    // plugins
    hideIntercom: false,
    hideFreshbot: false
    // hideFreshTicket: false
  }
};

const initialState = {
  name: '',
  route: '',
  path: '',
  lps: '',
  ...defaultPageInfo
};

const reducerMap = {
  [pageInfoTypes.SET_PAGE_INFO]({ info }) {
    return { layoutOptions: {}, ...info };
  },
  [pageInfoTypes.SET_LPS]({ lps }) {
    return { lps };
  }
};

const reducer = (state = initialState, action) => {
  const actionHandler = reducerMap[action.type];
  return actionHandler
    ? {
        ...state,
        ...actionHandler(action, state)
      }
    : state;
};

export default reducer;
